"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieChart = void 0;
var React = require("react");
var react_chartjs_2_1 = require("react-chartjs-2");
var chart_1 = require("../../theme/chart");
var PieChart = /** @class */ (function (_super) {
    __extends(PieChart, _super);
    function PieChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PieChart.prototype.render = function () {
        var _a = this.props, dataItems = _a.dataItems, showLegend = _a.showLegend, centerElement = _a.centerElement, width = _a.width, height = _a.height, hideToolTip = _a.hideToolTip;
        return (React.createElement("div", { style: { position: 'relative' } },
            React.createElement("div", { style: {
                    position: 'absolute',
                    margin: 'auto',
                    textAlign: 'center',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    pointerEvents: 'none',
                } }, centerElement),
            React.createElement(react_chartjs_2_1.Doughnut, { width: width, height: height, options: {
                    responsive: true,
                    cutoutPercentage: 80,
                    rotation: 0.05 * Math.PI,
                    layout: {
                        padding: 0,
                    },
                    tooltips: __assign(__assign({}, chart_1.tooltipOptions), (hideToolTip && {
                        enabled: false,
                    })),
                }, data: {
                    labels: dataItems.map(function (_a) {
                        var label = _a.label;
                        return label;
                    }),
                    datasets: [
                        {
                            data: dataItems.map(function (_a) {
                                var dataSize = _a.dataSize;
                                return dataSize;
                            }),
                            backgroundColor: dataItems.map(function (_a) {
                                var backgroundColor = _a.backgroundColor;
                                return backgroundColor;
                            }),
                            borderColor: dataItems.map(function (di) {
                                return di.borderColor ? di.borderColor : di.backgroundColor;
                            }),
                            hoverBackgroundColor: dataItems.map(function (di) {
                                return di.hoverBackgroundColor
                                    ? di.hoverBorderColor
                                    : di.backgroundColor;
                            }),
                            hoverBorderColor: dataItems.map(function (di) {
                                return di.hoverBorderColor
                                    ? di.hoverBorderColor
                                    : di.backgroundColor;
                            }),
                            borderWidth: 0,
                        },
                    ],
                }, legend: {
                    display: !!showLegend,
                } })));
    };
    return PieChart;
}(React.Component));
exports.PieChart = PieChart;
//# sourceMappingURL=index.js.map